import React from 'react';
import ReactDOM from 'react-dom';
import {Link} from 'react-router-dom';
import {translate} from 'react-i18next';
import copy from 'clipboard-copy';
import moment from 'moment';
import IndexPlayer from './IndexPlayer';
import Snackbar from './Snackbar';

const modalRoot = document.getElementById('modal-root');

class PhotoSetView extends React.PureComponent {

    constructor(props) {

        super(props);

        this.el = document.createElement('div');

        this.handleCloseClick = this.handleCloseClick.bind(this);
        this.handleDocumentKeyUp = this.handleDocumentKeyUp.bind(this);
        this.handleIndexChange = this.handleIndexChange.bind(this);
        this.handleShareClick = this.handleShareClick.bind(this);
    }

    componentDidMount() {

        modalRoot.appendChild(this.el);
        document.addEventListener('keyup', this.handleDocumentKeyUp);
    }

    componentWillUnmount() {

        modalRoot.removeChild(this.el);
        document.removeEventListener('keyup', this.handleDocumentKeyUp);
    }

    handleCloseClick() {

        if (this.props.onClose)
            this.props.onClose();
    }

    handleDocumentKeyUp(e) {

        if (e.keyCode === 27) { // Esc

            e.preventDefault();
            this.handleCloseClick();
        }
    }

    handleIndexChange(index) {

        if (this.props.onActivePhotoChange)
            this.props.onActivePhotoChange(this.props.photoSet.photos[index]);
    }

    async handleShareClick() {

        await copy(window.location.href);
        Snackbar.show({message: this.props.t('photoSetView.copied')});
    }

    getDisplayText() {

        const parts = [
            this.props.photoSet.photos.indexOf(this.props.activePhoto) + 1 ,
            this.props.activePhoto.description ? `"${this.props.activePhoto.description}"` : null,
            this.props.activePhoto.tags.length > 0 ? this.props.activePhoto.tags.map(tag => `#${tag}`).join(', ') : null,
            moment.utc(this.props.activePhoto.time).local().format('D MMMM YYYY, HH:mm'),
        ];

        return parts.filter(x => x !== null).join(', ');
    }

    render() {
        const coords = [this.props.photoSet.latitude, this.props.photoSet.longitude];
        const contents = (

            <div className="photo-view d-flex flex-column bg-dark text-light">
                <nav className="navbar">

                    <span className="d-none d-sm-inline-block text-truncate mr-2" style={{flex: 1}}>{this.getDisplayText()}</span>

                    <div className="btn-group ml-auto">
                        { this.props.isPhotoLocationNearUserLocation(coords) && 
                            <Link className="btn btn-light" to={`/camera?photoSet=${this.props.photoSet.id}`}><i className="fas fa-camera"/></Link>
                        }
                        <button type="button" className="btn btn-light" onClick={this.handleShareClick}><i className="fas fa-share-alt"/></button>
                        <button type="button" className="btn btn-light" onClick={this.handleCloseClick}><i className="fas fa-times"/></button>
                    </div>

                    <span className="d-sm-none text-right text-truncate w-100 mt-2">{this.getDisplayText()}</span>

                </nav>
                <div className="container" style={{flex: 1, overflow: 'hidden' /* Not sure why, but this seems to be necessary. */}}>
                    <div className="row h-100">

                        <div className="col h-100 text-center">
                            <img src={this.props.activePhoto.filename} alt={this.props.activePhoto.description} className="img-thumbnail h-100" style={{objectFit: 'cover'}}/>
                        </div>

                    </div>
                </div>
                <nav className="navbar justify-content-center">

                    <IndexPlayer items={this.props.photoSet.photos} index={this.props.photoSet.photos.indexOf(this.props.activePhoto)} onIndexChange={this.handleIndexChange}/>

                </nav>
            </div>
        );

        return ReactDOM.createPortal(contents, this.el);
    }
}

export default translate()(PhotoSetView);



// WEBPACK FOOTER //
// ./src/components/PhotoSetView.js